/**
* Kustomoitu dropdown.
* Defokusoituu, kun klikataan muualle.
* Kun droparia klikataan, näytetään direktiivin sisään puskettu content
* ja kutsutaan onOpened -callbackia.
* Kun droparia itseään klikataan silloin kun se on auki, piilotetaan sisäinen
* content ja kutsutaan onClosed -callbackia.
* Jos closeOnContentClick on asetettu trueksi, dropari sulkeutuu heti kun on klikattu droparin sisältöä.
* Kuunnellaan 'close-dropdown' -viestiä, josta droparin sisältö piilotetaan (mahdollistaa kompleksiset
* droparien sisällöt).
*
* Defaulttina tagin sisälle sijoitetut sisällöt tulee DOMmissa heti droparielementin jälkeen.
* Jos halutaan sijoittaa sisältö tagin ulkopuolelle, on käytettävä onOpened/onClosed-callbackeja, jotka
* saavat itse määritellä kuinka laittaa sisältönsä näkyviin, eli dropari ei ota siihen enempää kantaa.
*
* selectedText: 		teksti, joka näytetään droparissa ns. valittuna.
* onOpened: 			callback, kutsutaan kun dropari avautuu. Tarvitaan aina, jos sisältö on droparin
*						ulkopuolella, ja sen vastuulla on droparin sisällön näyttäminen.
* onClosed:				callback, kutsutaan kun dropari sulkeutuu. Tarvitaan aina, jos sisältö on droparin
*						ulkopuolella, ja sen vastuulla on droparin sisällön piilottaminen.
* contentSelector:		jQuery-selektori, käytä jos et sijoita droparin sisältöä droparin tagien sisään.
* closeOnContentClick:	suljetaanko dropari automaattisesti jos klikattiin sen contentin sisällä
* 
* EVENTS:
*
* customized-dropdown/close:  sulkee droparin.
*
*/
app.directive('customizedDropdown', ["$rootScope", "$timeout", function($rootScope, $timeout) {
	
	return {

		restrict: 'EA',
		templateUrl: 'customized-dropdown.html',
		transclude: true,
		scope: {
			selectedText: '=',
			//name: '='
			//onOpened: '&',
			//onClosed: '&',
			contentSelector: '@',
			name: '@'
		},

		link: function(scope, element, attrs) {

			$(element).addClass("customized-dropdown");

			scope.closeOnContentClick = true;
			if(typeof attrs.closeOnContentClick != 'undefined') {
				scope.closeOnContentClick = attrs.closeOnContentClick == 'true';
			}
			if(typeof attrs.openOnHover != 'undefined') {
				scope.openOnHover = attrs.openOnHover == 'true';
			}
			/*if(typeof attrs.contentSelector != 'undefined') {
				scope.contentSelector = attrs.contentSelector;
			}*/
			if(typeof attrs.onOpened != 'undefined') {
				scope.onOpened = attrs.onOpened;
			}
			if(typeof attrs.onClosed != 'undefined') {
				scope.onClosed = attrs.onClosed;
			}

			var contentSelector = scope.contentSelector;

			if(scope.openOnHover) {

				if(typeof contentSelector == 'string') {
					var contentElem = $(contentSelector);

					contentElem.hover(
						function() {
							scope.$apply(function() {
								scope.hoveringOverContent = true;
								if(typeof scope.hoverTimeout != 'undefined') {
									scope.CancelHide();
								}
							});
							
						},
						function() {
							scope.$apply(function() {
								scope.hoveringOverContent = false;
								scope.TriggerHide();
							});
						}
					);
				}


				$(element).hover(
					function() {
						scope.$apply(function() {
							scope.contentHidden = false;
							scope.hoveringOverElement = true;

							if(typeof scope.hoverTimeout != 'undefined') {
								scope.CancelHide();
							}
							scope.CallOpenCallback();

							/*
							if(typeof scope.onOpened == 'function') {
								if(typeof scope.hoverTimeout != 'undefined') {
									scope.CancelHide();
								}
								scope.onOpened();
							}
							*/
						});
					},
					function() {
						scope.$apply(function() {
							scope.hoveringOverElement = false;
							scope.TriggerHide();
						});
					}
				);
			}


			$(document).on('click', function(e) {

				var isClickedElementMyChild = element.find(e.target).length > 0;
				var isClickedElementMe = element[0] == e.target;
				var isClickedElementContent = (isClickedElementMyChild && $(e.target).parents("[dropdown-content]").length > 0) || 
												(typeof(scope.contentSelector) == 'string' && ($(e.target).parents(scope.contentSelector).length > 0 || $(e.target)[0] == $(scope.contentSelector)[0]));
				var isClickedElementChildOrMe = element.find(e.target).length > 0 || element[0] == e.target;

				// Sulkemisehdot
				if(!scope.contentHidden && (
					// Clicked element that is my element and did not click inside dropdown content
					( isClickedElementChildOrMe && !isClickedElementContent ) || 
					// Close on content click is true
					( scope.closeOnContentClick && 
						// and either we clicked the dropdown content or the dropdown itself
						( isClickedElementContent || isClickedElementChildOrMe )
					) || 
					// or we clicked completely outside the content and the dropdown, and our content is a child
					( !isClickedElementChildOrMe && !isClickedElementContent) 
					) ) {
					scope.$apply(function() {
						scope.Hide();
					});					
					return;
				}
				// Näyttämisehdot
				else if(scope.contentHidden && isClickedElementChildOrMe) {
					scope.$apply(function() {
						scope.contentHidden = false;
						scope.CallOpenCallback();
					});					
					return;
				}


				scope.$apply();
				

			});
		},

		controller: ["$scope", function($scope) {
			$scope.contentHidden = true;
			$scope.hoverTimeout = undefined;
			$scope.hoveringOverElement = false;
			$scope.hoveringOverContent = false;

			$scope.TriggerHide = function() {

				if(!$scope.hoveringOverElement && !$scope.hoveringOverContent) {
					$scope.hoverTimeout = $timeout(function() {
						$scope.Hide();
					}, 300);
				}

			};

			$scope.CallOpenCallback = function() {
				if(typeof $scope.onOpened != 'undefined') {
					$scope.$parent.$eval($scope.onOpened);
				}
			};

			$scope.CallCloseCallback = function() {
				if(typeof $scope.onClosed != 'undefined') {
					$scope.$parent.$eval($scope.onClosed);
				}
			};

			$scope.CancelHide = function() {
				$timeout.cancel($scope.hoverTimeout);
			};

			$scope.$on('customized-dropdown/' + $scope.name + '/close', function(event, args) {
				$scope.Hide();
			});

			$scope.Hide = function() {
				$scope.contentHidden = true;
				$scope.CallCloseCallback();
			};

		}]
	};

}]);
	
